import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { ReactComponent as Close } from "icons/Close.svg";
import { initialValues } from "../constants";
import styles from "./styles.module.scss";
import { CustomDropDown } from "components/CustomDropDown";

export function FilterModal({
  formValues,
  isPopupOpen,
  setIsPopupOpen,
  clearHandler,
  onFinish,
}: any) {
  const [modalValues, setModalValues] = useState(initialValues);

  useEffect(() => {
    setModalValues(formValues);
  }, []);

  function handleCancel() {
    setIsPopupOpen(false);
  }

  function formDataHandler(title: any, value: any) {
    setModalValues({
      ...modalValues,
      [title]: value,
    });
  }

  function submitHandler(event: any) {
    event.preventDefault();
    setIsPopupOpen(false);
    onFinish(modalValues);
  }

  function clearModalValues() {
    setModalValues(initialValues);
    clearHandler();
  }

  return (
    <Modal
      title=""
      open={isPopupOpen}
      cancelText="No"
      style={{ top: 200 }}
      okText="Yes"
      width={1350}
      footer={null}
      onCancel={handleCancel}
      closeIcon={<Close />}
    >
      <div className={styles.filterModal}>
        <div className={styles.titleContainer}>
          <h1>Select filter</h1>
        </div>
        <div className={styles.formContainer}>
          <form onSubmit={submitHandler}>
            <FormItem label="Time Interval" className={styles.antDateItem}>
              <CustomDropDown
                onChangeHandler={formDataHandler}
                value={modalValues?.timeInterval}
              />
            </FormItem>

            <div className={styles.formBtn}>
              <button type="submit">Apply</button>
              <div className={styles.historyLine} />
              <span className={styles.clear} onClick={clearModalValues}>
                Clear all
              </span>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}

export function FormItem({ children, label, className }: any) {
  const containerClasses = [styles.formItem, className].join(" ");
  return (
    <div className={containerClasses}>
      <label>{label}</label>
      <div>{children}</div>
    </div>
  );
}
